import { render, staticRenderFns } from "./HeadingSettings.vue?vue&type=template&id=6f5ff1fb"
import script from "./HeadingSettings.vue?vue&type=script&lang=ts"
export * from "./HeadingSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5ff1fb')) {
      api.createRecord('6f5ff1fb', component.options)
    } else {
      api.reload('6f5ff1fb', component.options)
    }
    module.hot.accept("./HeadingSettings.vue?vue&type=template&id=6f5ff1fb", function () {
      api.rerender('6f5ff1fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/HeadingSettings.vue"
export default component.exports